
import { supabase } from '@/integrations/supabase/client';
import { PlacesSearchResponse, PlaceResult } from '@/types/place';

/**
 * Create a mock API handler for places search during CSV import
 * This will use the real edge function in production, but provides
 * a way to test locally with mocked data
 */
export const setupMockPlacesApi = () => {
  // Create a function to intercept fetch calls to our mock API endpoint
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    // Check if this is a request to our mock places API
    if (typeof url === 'string' && url.startsWith('/api/places/search')) {
      // Extract the query parameter
      const urlObj = new URL(url, window.location.origin);
      const query = urlObj.searchParams.get('query');
      const limit = urlObj.searchParams.get('limit') || '5';
      
      if (!query) {
        return Promise.resolve(new Response(JSON.stringify({ 
          results: [],
          status: 'INVALID_REQUEST'
        }), {
          status: 400,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      
      // Call the real Supabase edge function for places search
      return supabase.functions.invoke('places-search', {
        body: { query, limit: parseInt(limit, 10) }
      }).then(response => {
        // Convert the Supabase response to a fetch Response
        return new Response(JSON.stringify(response.data), {
          status: response.error ? 500 : 200,
          headers: { 'Content-Type': 'application/json' }
        });
      }).catch(error => {
        console.error('Error calling places-search function:', error);
        return new Response(JSON.stringify({ 
          error: 'Failed to fetch places search results',
          status: 'ERROR'
        }), {
          status: 500,
          headers: { 'Content-Type': 'application/json' }
        });
      });
    }
    
    // For all other requests, use the original fetch
    return originalFetch.apply(this, [url, options]);
  };
};

// Setup the mock API when this module is imported
setupMockPlacesApi();
